import { licenseJournalService } from '_services';
import { ACTIONS_LICENSE_JOURNAL } from '_constants/licenseJournal.constants';
import alertActions from './alert.actions';

export const receiveLicenseJournals = (licenseJournals) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < licenseJournals.length; i++) {
    byIdObjectToDispatch[licenseJournals[i].licenseJournalID] = licenseJournals[i];
  }

  return {
    type: ACTIONS_LICENSE_JOURNAL.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteLicenseJournal = (licenseJournalId) => ({
  type: ACTIONS_LICENSE_JOURNAL.DELETE,
  byId: { [licenseJournalId]: null }
});

const getLicenseJournals = (accountID) => async (dispatch) => {
  try {
    const resp = await licenseJournalService.getLicenseJournals(accountID);
    if (resp?.[0]?.licenseJournalID) {
      dispatch(receiveLicenseJournals(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving license journals.'));
  }
  return null;
};

const licenseJournalActions = {
  getLicenseJournals
};

export default licenseJournalActions;
